import { NgModule } from '@angular/core';
import { CommonModule, CurrencyPipe, DatePipe } from '@angular/common';
import { MatToolbarModule } from '@angular/material/toolbar';
import { RouterModule } from '@angular/router';
import {
  provideHttpClient,
  withInterceptorsFromDi,
  withXhr
} from '@angular/common/http';
import { MaterialModule } from './material/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { FilterPipe } from './pipes/filter/filter.pipe';
import { UniquePipe } from './pipes/unique/unique.pipe';
import { StringifyPipe } from './pipes/stringify.pipe';
import { SafeHtmlPipe } from './pipes/safe-html.pipe';
import { BusinessFooterComponent } from './components/business-footer/business-footer.component';
import { BusinessHeaderComponent } from './components/business-header/business-header.component';
import { ModalComponent } from './components/modal/modal.component';

@NgModule({
  declarations: [
    BusinessFooterComponent,
    BusinessHeaderComponent,
    FilterPipe,
    StringifyPipe,
    UniquePipe,
    SafeHtmlPipe,
    ModalComponent
  ],
  exports: [
    BusinessFooterComponent,
    BusinessHeaderComponent,
    ModalComponent,
    FilterPipe,
    StringifyPipe,
    UniquePipe,
    SafeHtmlPipe
  ],
  imports: [
    CommonModule,
    FormsModule,
    MaterialModule,
    MatToolbarModule,
    ReactiveFormsModule,
    RouterModule
  ],
  providers: [
    DatePipe,
    CurrencyPipe,
    provideHttpClient(withXhr(), withInterceptorsFromDi())
  ]
})
export class SharedModule {}
